<span class="category">new routes: </span> {{ newRouteCount }}<br />
<span class="category">removed routes: </span> {{ removedRouteCount }}<br />
<span class="category">changed routes: </span> {{ changedRouteCount }}
